<template>
    <b-collapse :visible="showGraph" id="content">
        <card>
            <div slot="header" class="row align-items-center">
                <div class="col">
                    <!--<h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>-->
                    <h5 class="h3 mb-0">Open PAs</h5>
                </div>
            </div>
            <div class="overflow-auto">
                <b-pagination v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              aria-controls="openPAsTable">
                </b-pagination>
                <b-table id="openPAsTable"
                         :items="tableData"
                         :fields="tableColumns"
                         :per-page="perPage"
                         :current-page="currentPage"
                         small
                         striped>
                </b-table>
            </div>
        </card>
    </b-collapse>
</template>

<script>
    import * as chartConfigs from '@/components/Charts/config';
    import LineChart from '@/components/Charts/LineChart';
    import BarChart from '@/components/Charts/BarChart';

    export default {
        name: 'open-pa-charts',
        components: {
            LineChart,
            BarChart
        },
        props: {
            apiEndpoint: String
        },
        data() {
            return {
                showGraph: false,
                tableColumns: [
                    { key: 'drug', sortable: true },
                    { key: 'prescriber', sortable: true },
                    { key: 'npi', sortable: true },
                    { key: 'company', sortable: true },
                    { key: 'status', sortable: true }
                ],
                perPage: 10,
                currentPage: 1,
                tableData: [],
                drugData: [],
                bigLineChart: {
                    allData: [
                        [],
                        []
                    ],
                    activeIndex: 0,
                    chartData: {
                        datasets: [],
                        labels: [],
                    },
                    extraOptions: chartConfigs.blueChartOptions,
                },
                redBarChart: {
                    chartData: {
                        datasets: [],
                        labels: [],
                    },
                }
            };
        },
        methods: {
            initBigChart(index) {
                this.bigLineChart.chartData = this.bigLineChart.allData[index];
                this.bigLineChart.activeIndex = index;
            },
            fetchData() {
                this.axios.get(this.apiEndpoint)
                        .then(response => {
                            this.drugData = response.data;
                            this.tableData = response.data.map(d => {
                                return {
                                    drug: d.drugName,
                                    prescriber: d.lastName + ", " + d.firstName,
                                    npi: d.npi,
                                    company: d.company,
                                    status: d.statusName
                                };
                            })
                        })
                        .catch(error => {
                            
                        });
            },

        },
        watch: {
            npiNumber: function () {
                if (this.npiNumber.match(/^[0-9]+$/) != null && this.npiNumber.length === 10 || this.npiNumber.includes(', ')) {
                    this.fetchData();
                }
                else {
                    return false
                }
            },
            apiEndpoint: function () {
                this.currentPage = 1;
                this.fetchData();

            },
            drugData: function (drugs) {
                function groupBy(list, keyGetter) {
                    const map = new Map();
                    list.forEach(item => {
                        const key = keyGetter(item);
                        const collection = map.get(key);
                        if (!collection) {
                            map.set(key, [item]);
                        } else {
                            collection.push(item);
                        }
                    });
                    return map;
                }
                let drugsData = groupBy(drugs, d => d.drugName);
                this.bigLineChart.allData = [];
                let count = [];
                let labels = [];
                drugsData.forEach(e => {
                    count.push(e.length);
                    labels.push(e[0].drugName);

                    this.bigLineChart.allData.push({
                        labels: e.map(d => `${d.drugName}`),
                        datasets: [{
                            label: `${e[0].lastName}, ${e[0].firstName}`,
                            data: e.map(d => e.length),
                        }],
                        drug: e[0].drugName,
                    });
                });
                let chartData = {
                    labels: labels,
                    datasets: [{
                        label: 'Open PAs',
                        data: count
                    }],
                };
                if (chartData.labels.length > 0) {
                    this.showGraph = true
                }
                else {
                    this.showGraph = false
                }
                this.redBarChart.chartData = chartData;
                this.initBigChart(0)
            },
        },
        computed: {
            rows() {
                return this.tableData.length
            }
        },
        mounted() {
            //this.fetchData();
        }
    }
</script>

<style scoped>
</style>